export default __webpack_public_path__ + "static/media/woman.f61b791a.png";